import { assetUrl } from './assetUrl';

export const PROFILE_PATTERNS = [
  assetUrl('/images/profile/pattern-blue.webp'),
  assetUrl('/images/profile/pattern-red.webp'),
  assetUrl('/images/profile/pattern-green.webp'),
  assetUrl('/images/profile/pattern-purple.webp'),
  assetUrl('/images/profile/pattern-grey.webp'),
] as const;

export type ProfilePattern = (typeof PROFILE_PATTERNS)[number];

export function isValidProfilePattern(
  value: string | undefined | null
): value is ProfilePattern {
  return !!value && PROFILE_PATTERNS.includes(value as ProfilePattern);
}

export function getProfilePattern(
  index: number,
  existingPattern?: string
): ProfilePattern {
  // Preserve an existing valid pattern if present
  if (isValidProfilePattern(existingPattern)) {
    return existingPattern as ProfilePattern;
  }
  // Deterministic assignment based on index; wrap with modulo as safeguard
  const safeIndex =
    Number.isFinite(index) && index >= 0 ? index % PROFILE_PATTERNS.length : 0;
  return PROFILE_PATTERNS[safeIndex];
}
